import React from 'react';
import './Skills.css';
import './styles/global.css';
// Note: Add Proper Icons Later

const backendSkills = [
  {
    // icon: (
    //   <svg className="skill-icon" viewBox="0 0 48 48"><path m stroke="#ff2d2d" strokeWidth="4"/></svg>
    // ),
    title: '.Net',
    desc: 'MS App Framework',
  },
  {
    // icon: (
    //   <svg className="skill-icon" viewBox="0 0 48 48"><circle cx="24" cy="24" r="20" fill="none" stroke="#ff2d2d" strokeWidth="4"/><path d="M24 14v10l8 8" stroke="#ff2d2d" strokeWidth="4"/></svg>
    // ),
    title: 'SpringBoot',
    desc: 'Java Framework',
  },
  
];

const languages = [
  {
    title: 'Java',
    desc: 'Object-Oriented Programming Language'
  },
  {
    title: 'Python',
    desc: 'Scripting Language'
  },
  {
    title: 'JavaScript',
    desc: 'Web Scripting Language'
  },
  {
    title: 'C#',
    desc: 'Object-Oriented .Net Language'
  },
]

const frontend = [
  {
    title: 'HTML and CSS',
    desc: 'Web Designing Language'
  },
  {
    title: 'React js/ts',
    desc: 'UI Component Library'
  },
  {
    title: 'React Native',
    desc: 'Mobile App Framework'
  },

]

const machineLearning = [
  {
    title: 'PyTorch',
    desc: 'Deep Learning Framework'
  },
  {
    title: 'Numpy',
    desc: 'Numerical/Tensor Computing Library'
  },
  {
    title: 'Pandas',
    desc: 'Data Analysis Library'
  },
  {
    title: 'Scikit-Learn',
    desc: 'ML Library'
  },

]

const databases = [
  {
    title: 'MySQL',
    desc: 'Relational DB System'
  },
  {
    title: 'PostgresSQL',
    desc: 'SQL Based DB'
  },
  

]

const devopsSkills = [
  {
    title: 'AWS',
    desc: 'Cloud Computing Service'
  },
  {
    title: 'Azure',
    desc: 'Microsoft Cloud Service'
  },
  {
    title: 'Docker',
    desc: 'Containerization Tool'
  },
  {
    title: 'Postman',
    desc: 'API Testing Platform'
  },
  {
    title: 'GIT',
    desc: 'Source Control System',
  }
];



const Skills = () => (
  <div className="container">
    {/* Languages Section */}
    <section className="skills-section">
      <div className="skills-category">
        Languages
        <span className="underline"></span>
      </div>
      <div className="skills-grid">
        {languages.map((skill, idx) => (
          <div className="skill-card" key={idx}>
            {skill.icon}
            <div className="skill-title">{skill.title}</div>
            <div className="skill-desc">{skill.desc}</div>
          </div>
        ))}
      </div>
    </section>

    {/* Frontend Section */}
    <section className="skills-section">
      <div className="skills-category">
        Frontend
        <span className="underline"></span>
      </div>
      <div className="skills-grid">
        {frontend.map((skill, idx) => (
          <div className="skill-card" key={idx}>
            {skill.icon}
            <div className="skill-title">{skill.title}</div>
            <div className="skill-desc">{skill.desc}</div>
          </div>
        ))}
      </div>
    </section>

    {/* ML Section */}
    <section className="skills-section">
      <div className="skills-category">
        Machine Learning 
        <span className="underline"></span>
      </div>
      <div className="skills-grid">
        {machineLearning.map((skill, idx) => (
          <div className="skill-card" key={idx}>
            {skill.icon}
            <div className="skill-title">{skill.title}</div>
            <div className="skill-desc">{skill.desc}</div>
          </div>
        ))}
      </div>
    </section>

    {/* Backend Section */}
    <section className="skills-section">
      <div className="skills-category">
        Backend
        <span className="underline"></span>
      </div>
      <div className="skills-grid">
        {backendSkills.map((skill, idx) => (
          <div className="skill-card" key={idx}>
            {skill.icon}
            <div className="skill-title">{skill.title}</div>
            <div className="skill-desc">{skill.desc}</div>
          </div>
        ))}
      </div>
    </section>

    {/* DB Section */}
    <section className="skills-section">
      <div className="skills-category">
        Databases
        <span className="underline"></span>
      </div>
      <div className="skills-grid">
        {databases.map((skill, idx) => (
          <div className="skill-card" key={idx}>
            {skill.icon}
            <div className="skill-title">{skill.title}</div>
            <div className="skill-desc">{skill.desc}</div>
          </div>
        ))}
      </div>
    </section>

    {/* Cloud & DevOps Section */}
    <section className="skills-section">
      <div className="skills-category">
        Cloud & DevOps
        <span className="underline"></span>
      </div>
      <div className="skills-grid">
        {devopsSkills.map((skill, idx) => (
          <div className="skill-card" key={idx}>
            {skill.icon}
            <div className="skill-title">{skill.title}</div>
            <div className="skill-desc">{skill.desc}</div>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default Skills;

